import React, { ElementType, ReactComponentElement, ReactElement, useEffect, useRef, useState } from "react";
import { Pack, UITrack, User } from "../../firebase/firestore";

export default function PackTitle({
  value,
  setValue = null,
  editable,
  className,
  subtitle,
  icons,
  ...rest
}: {
  value: string;
  setValue?: (v: string) => Promise<any>;
  className?: string;
  editable: boolean;
  subtitle?: any;
  icons?: any;
}) {
  const [intermediate, setIntermediate] = useState(value);
  useEffect(() => setIntermediate(value), [value]);
  const [loading, setLoading] = useState(false);
  const submitValue = async () => {
    setLoading(true);
    await setValue(intermediate);
    setLoading(false);
  };
  const [focused, setFocused] = useState(false);

  const inputRef = useRef(null);
  const conClassName = `w-full relative group z-10 text-center `;
  const inputClass = ` ${className} text-loadable ${
    loading && "text-loading"
  } text-center w-full text-4xl bg-transparent outline-none border-none placeholder:text-muted text-white`;
  const subClassName = `mt-2 text-light-gray text-sm`;

  const onButtonClick = () => {
    if (focused) {
      inputRef.current.blur();

      submitValue();
    } else {
      inputRef.current.focus();
    }
  };
  if (editable)
    return (
      <div className={conClassName} {...rest}>
        <input
          ref={inputRef}
          value={intermediate}
          onBlur={() => {
            setFocused(false);
            submitValue();
          }}
          onKeyDown={(e) => e.key === "Enter" && submitValue()}
          onFocus={() => setFocused(true)}
          onChange={(e) => setIntermediate(e.target.value)}
          maxLength={256}
          className={inputClass + " leading-3"}
          placeholder="name your pack"
          type={"text"}
        />
        {value && (
          <div
            onClick={onButtonClick}
            className="absolute cursor-pointer left-full  top-1/2 -translate-y-1/2 text-sm opacity-40"
          >
            {focused ? "Save" : "Edit"}
          </div>
        )}
        {subtitle && <div className={subClassName}>{subtitle}</div>}
      </div>
    );
  return (
    <div className={conClassName} {...rest}>
      <div className=" relative flex items-center">
        <span className={inputClass}>{intermediate}</span>
        <div className="absolute left-full top-1/2 -translate-y-1/2">{icons}</div>
      </div>
      {subtitle && <div className={subClassName}>{subtitle}</div>}
    </div>
  );
}
export type PackTracksProps = {
  tracks: UITrack[];
  selectTrack?: (uiTrack: UITrack) => void;
  deselectTrack?: (uiTrack: UITrack) => void;
  setTracks: React.Dispatch<React.SetStateAction<UITrack[]>>;
  canAdd?: boolean;
  canSelect?: boolean;
  canEdit: boolean;
  onDelete: (uiTrack: UITrack) => any;
  onAdd: () => any;
  creator?: User;
  customAddTracksMessage?: string;
  showTrackAuthors?: boolean;
  canEditOwnTracks?: boolean;

  // message to show when canAdd is false
  cantAddMessage?: ReactElement<any, any>;

  
  pack?: Pack;
};
